import { render, staticRenderFns } from "./AssociatedInstrumentsCard.vue?vue&type=template&id=15163fab"
import script from "./AssociatedInstrumentsCard.vue?vue&type=script&lang=js"
export * from "./AssociatedInstrumentsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports